import { useAppDispatch, useAppSelector } from '@app/hooks';
import { useEffect } from 'react';
import _ from 'lodash';
import { getAllStressAreaType } from '@app/store/stressAreaType/reducer';

export const useStressAreaType = (): void => {
    const { isFetching, lastUpdated, stressAreaTypes } = useAppSelector(
        (state) => state.stressAreaType
    );
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!isFetching && stressAreaTypes.length === 0 && !lastUpdated) {
            dispatch(getAllStressAreaType());
        }
    }, []);
};
